import React from "react";
import { styled } from "@mui/material";
const ContentBoxWrapper = styled("div")(({ theme }) => ({
  marginLeft: "30px",
  marginRight: "30px",
  marginTop: "10px",
  marginBottom: "0px",
  [theme.breakpoints.down("sm")]: { margin: "16px" }
}));
function ContentBox({ children, sx = {} }) {
  return <ContentBoxWrapper sx={sx}>{children}</ContentBoxWrapper>;
}

export default ContentBox;
